import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UserService } from '../../../services/core.user.service';

import * as _ from 'lodash-es';
import { StateService } from '@uirouter/angular';
import { AdminService } from '../../../services/core.admin.service';
import { ConstantsService } from '../../../services/core.constants.service';

import { GfTitleService } from '../../../services/core.title.service';
import { UserRest } from '../../../services/core.user.rest.service';
import { UiService } from '../../../services/core.ui.service';
import { SettingService } from '../../../services/core.setting.service';
import { GfTranslateService } from '../../../services/core.translate.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AdminChangePasswordComponent } from '../change-password/admin.change-password.component';

@Component({
    selector: 'admin-user-edit-view',
    template: require('./admin.user-edit.component.html')
})
export class AdminUserEditComponent implements OnInit {

    @Input() siteConfig: any = null;

    protected options = {
        language: this.constantsService.languages,
        country: this.constantsService.countries,
        timezone: this.constantsService.timezones
    };

    protected userGroups = {
        alias: 'groups',
        fieldData: [],
    };
    
    protected projects = [];
    protected groups = [];

    protected statuses = {
        '-1': 'Pending approval',
        '0': 'Pending',
        '1': 'Active',
        '2': 'Deleted',
        '3': 'Suspended'
    };

    protected user: any = null;
    private customAvatar: any = null;
    protected avatarPreview: any = null;
    private sortFields = { id: 'Join Date', unixName: 'Unix Name' };
    private errors = {};
    protected tab: string = '';
    protected canChangePassword: boolean = false;
    protected readOnly: boolean = true;

    constructor(
        private stateService: StateService, 
        private adminService: AdminService, 
        private constantsService: ConstantsService,
        private userRest: UserRest, 
        private uiService: UiService, 
        private userService: UserService, 
        private settingService: SettingService, 
        private gfTranslateService: GfTranslateService,
        private $window: Window,
        private modalService: NgbModal,
        private titleService: GfTitleService,
    ) { }

    ngOnInit() {
        this.avatarPreview = '/api/user/' + this.stateService.params.unixName + '/avatar';

        this.titleService.setTitle('Site Admin', this.gfTranslateService.translate('Edit User'));
        this.tab = 'project';
        this.canChangePassword = (_.get(this.siteConfig, 'authenticationMode', 'db') == 'db');

        this.userRest.getProjects(this.stateService.params.unixName, {
            sort_dir: 'ASC',
            page_size: 50
        })
        .then((resource: any) =>{
            this.projects = resource.items;
        }, (response) =>{
            console.log(response);
        });

        this.adminService.users({ group: 1, page_size: 999 })
        .then((response: any) => {
            var fieldElements = _.map(response.items, (item) =>{
                return {
                    id: item.id,
                    label: item.firstname
                };
            });
            this.groups = fieldElements;
        });

        this.adminService.getUser(this.stateService.params.unixName)
        .then((data) => {
            this.user = data;
            this.readOnly = (this.user.id < 101);

            this.userGroups.fieldData = _.get(this.user, 'rel.groups', []);
            this.avatarPreview = this.getAvatarPreview(this.user);

            this.user.ccode = _.find(this.options.country.fieldElements, { id: this.user.ccode });
            this.user.timezone = _.find(this.options.timezone.fieldElements, { id: this.user.timezone });
            this.user.language = _.find(this.options.language.fieldElements, { id: this.user.language });
        }, (response) => {
            console.log(response);
            this.stateService.go('home.admin.users');
        });
    };

    getAvatarPreview = (user) => `/api/user/${ user.unixName }/avatar`;

    setTab = (newTab) =>{ this.tab = newTab; };

    saveChanges = () =>{

        // The changes we make before submitting
        // are for API requirements only, they do not
        // change the state of the user.

        // For this reason, we change and submit a copy,
        // and leave the this.user set as the user left it.
        var user = _.cloneDeep(this.user);

        // Massage the cloned data before submitting, for UI/API differences.
        user.language = user?.language?.id ?? null;
        user.timezone = user?.timezone?.label ?? null;
        user.ccode = user?.ccode?.id ?? null;

        for (var x in user) {
            if (user[x] === null) {
                delete user[x];
            }
        }
        delete user.lastLogin;
        delete user.createDate;

        this.userRest.update(user.unixName, user)
        .then((r) =>{
            this.uiService.message.showSuccess('Changes saved', 'Success');

            if (user.useCustomAvatar == 'Y' && this.customAvatar) {
                this.userService.profile.uploadAvatar(
                    this.user.unixName,
                    this.customAvatar
                ).then((result) =>{
                    this.uiService.message.showSuccess("Avatar uploaded successfully");
                }, (result) => {
                    this.uiService.message.showError("Avatar failed to upload");
                });
            }
        }, (r) =>{
            this.errors = r.data;
            this.uiService.message.showError('User save failed', 'Error');
        });

    };

    clearError = (name) =>{
        if (this.errors[name]) {
            delete this.errors[name];
        }
    };

    valid = (name?) =>{
        return this.user.unixName && this.user.email && this.user.firstname &&
            this.user.lastname && _.isEmpty(this.errors);
    };

    setStatus = (value) =>{
        this.userRest.update(this.user.unixName, { unixName: this.user.unixName, status: value })
        .then((r) =>{
            this.user.status = value;
            this.uiService.message.showSuccess(this.user.unixName + ' is now ' + this.statuses[value], 'Success');
        });
    };

    onChangeCustomAvatar = (newValue) =>{
        this.user.useCustomAvatar = newValue;
        if (this.user.useCustomAvatar == 'N') {
            var isGroup = this.user.isGroup == 'Y';
            if (!isGroup) {
                this.avatarPreview = '/core/img/default-avatar.png';
            } else {
                this.avatarPreview = '/core/img/default-avatar-group.png';
            }
        } else {
            this.avatarPreview = '/api/user/' + this.stateService.params.unixName + '/avatar';
        }
    };

    getPreview = (file: File) =>{
        var fr = new FileReader();
        fr.addEventListener('load', () => { this.avatarPreview = fr.result; });
        fr.readAsDataURL(file);
    };

    fileSelected = ($event) => {
        this.addFile($event?.target?.files);
    };

    //when user selects a file store it locally, it will be uploaded
    // after submit creates a new valid tracker item
    addFile = ($files) => {
        var f = _.first($files);
        if (! f) {
            return;
        }

        this.getPreview(f as any);
        this.customAvatar = f;
        this.user.useCustomAvatar = 'Y';
    };

    showPasswordChange = () =>{
        const modalRef = this.modalService.open(AdminChangePasswordComponent);
        modalRef.componentInstance.user = this.user;
        modalRef.componentInstance.close = () => {
            modalRef.close();
        };
    };

    toggleAdmin = () =>{
        if (this.user.isSiteAdmin) {
            this.userRest.deleteAdmin(this.user.unixName)
                .then((r) =>{
                    this.user.isSiteAdmin = false;
                    this.uiService.message.showSuccess(this.user.unixName + ' is no longer a site admin', 'Success');
                })
                .catch((err) =>{
                    var $errorType = _.get(err, 'data.type', '');
                    if ($errorType == 'site_admin_count') {
                        this.uiService.message.showError(this.user.unixName + ' is the only active site admin and it cannot be removed', 'Error');
                    }
                });
        }
        else {
            this.userRest.setAdmin(this.user.unixName)
                .then((r) =>{
                    this.user.isSiteAdmin = true;
                    this.uiService.message.showSuccess(this.user.unixName + ' is now a site admin', 'Success');
                })
                .catch((err) =>{
                    this.uiService.message.showError(this.user.unixName + ' could not be set to site admin', 'Error');
                });
        }
    };

    unlockUser = () =>{
        this.settingService.post({
            section: 'user',
            refId: this.user.id,
            settingName: 'loginAttempts',
            settingValue: '0'
        }).then((ret) =>{
            this.user.rel.lock = false;
            this.uiService.message.showSuccess('User ' + this.user.unixName + ' has been unlocked', 'User Unlocked');
        })
        .catch(() =>{
            this.uiService.message.showError('User ' + this.user.unixName + ' could not be unlocked', 'Error');
        });
    };
}